import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  clearVolcanoLocationRedirect as clearVolcanoLocationRedirectAc,
  clearVolcanoLocations as clearVolcanoLocationsAc,
  getVolcanoLocations as getVolcanoLocationsAc,
} from '../../../../../../redux/volcanoes/location/search/volcanoLocationSearchActions';
import {
  bulkEditVolcanoLocations as bulkEditTsunamisAc,
  cancelEdit as cancelEditAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  clearVolcanoEventData as clearVolcanoEventDataAc,
  deleteVolcanoLocation as deleteVolcanoLocationAc,
  getRegions as getRegionsAc,
  openEditConfirmation as openEditConfirmationAc,
  sortData as sortDataAc,
  startEdit as startEditAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../../redux/volcanoes/location/data/volcanoLocationDataActions';
import { DeleteIcon } from '../../../../../icon/DeleteIcon';
import { EditIcon } from '../../../../../icon/EditIcon';
import { isDataManager } from '../../../../../../role/roleUtils';
import { Loading } from '../../../../../loadbar/Loading';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import {
  resolveSearchParameters,
} from '../search/volcanoLocationSearchParameterNameResolver';
import { ResultGrid } from '../../../../../grid/ResultGrid';
import { Column } from '../../../../../grid/Column';
import { createInitialForm, formToJson } from '../edit/volcanoLocationEditModel';
import { latLonCell, textCell } from '../../../../../grid/resultGridCells';
import {
  minColumns,
  sort as defaultSort,
  visibleColumns as defaultColumns,
} from '../../../../../../redux/volcanoes/location/data/volcanoLocationReduxConstants';

const renderEditLink = id => (
  <Link aria-label={`Edit Volcano Location ${id}`} to={`/view/hazards/volcano/loc-update/${id}`} target="_blank" rel="noopener noreferrer">
    <EditIcon />
  </Link>
);

const handleBeforeUnload = (event) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = 'leaving reference';
};

class VolcanoLocContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.focus = this.focus.bind(this);
    // this.handleSort = this.handleSort.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditToggle = this.handleEditToggle.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.deleteCancel = null;
    this.state = {
      queryParameters: {},
      modal: false,
      deleteId: null,
    };
  }


  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Location Results';
    const {
      clearVolcanoEventData,
      getRegions,
      getVolcanoLocations,
      clearVolcanoLocationRedirect,
      searchRedirect,
      location: { search },
      history,
    } = this.props;
    clearVolcanoEventData();
    getRegions({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      getVolcanoLocations({ queryParameters, history });
    } else {
      clearVolcanoLocationRedirect();
    }
    this.setState({ queryParameters });
  }

  componentDidUpdate(prevProps) {
    const {
      deleting,
      getVolcanoLocations,
      history,
      saving,
      cancelEditConfirmation,
      errors,
      cancelEdit,
    } = this.props;
    const { queryParameters } = this.state;
    if (!deleting && prevProps.deleting) {
      this.closeModal(() => {
        getVolcanoLocations({ queryParameters, history });
      });
    }
    if (!saving && prevProps.saving) {
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
      cancelEditConfirmation();
      if (!errors.size) {
        cancelEdit();
        getVolcanoLocations({ queryParameters, history });
      }
    }
  }

  componentWillUnmount() {
    const { clearVolcanoLocations, clearVolcanoEventData } = this.props;
    clearVolcanoLocations();
    clearVolcanoEventData();
  }

  focus() {
    this.deleteCancel.focus();
  }

  openModal(deleteId) {
    this.setState({
      modal: true,
      deleteId,
    });
  }

  closeModal(callback) {
    this.setState({
      modal: false,
      deleteId: null,
    }, callback);
  }

  handleYesClick() {
    const { deleteVolcanoLocation, history } = this.props;
    const { deleteId } = this.state;
    deleteVolcanoLocation({ id: deleteId, history });
  }

  // TODO change to edit path
  handleEditClick(id) {
    const { history } = this.props;
    history.push(`/view/hazards/volcano/loc-update/${id}`);
  }

  handleDeleteClick(id) {
    this.openModal(id);
  }

  handleSubmit(data) {
    const { bulkEditVolcanoLocations } = this.props;
    bulkEditVolcanoLocations({ data });
  }

  handleEditToggle(edit) {
    const { startEdit, cancelEdit, volcanoLocations } = this.props;
    if (edit) {
      const items = {};
      const initialValues = { items };
      volcanoLocations.forEach((item) => {
        items[`${item.get('id')}`] = createInitialForm(item).toJS();
      });
      startEdit({ initialValues });
      window.addEventListener('beforeunload', handleBeforeUnload, true);
    } else {
      cancelEdit();
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
    }
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  render() {
    const {
      volcanoLocations,
      fetched,
      deleting,
      authorities,
      peopleDescriptors,
      damageDescriptors,
      regions,
      sort,
      visibleColumns,
      editConfirmationOpen,
      saving,
      formData,
      cancelEditConfirmation,
      openEditConfirmation,
      initialFormData,
      initialValues,
      editing,
      errors,
    } = this.props;
    const { modal, queryParameters } = this.state;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters, regions, peopleDescriptors, damageDescriptors,
    });

    return (
      <div className="haz-results-container haz-page-container">
        <Modal isOpen={modal || deleting} onOpened={this.focus} backdrop="static">
          <ModalHeader>Delete Volcano Location</ModalHeader>
          <ModalBody>
            {deleting ? 'Deleting...' : 'Are you sure you want to delete the volcano location?'}
          </ModalBody>
          <ModalFooter>
            <Button disabled={deleting} color="danger" onClick={this.handleYesClick}>Delete</Button>
            {' '}
            <Button disabled={deleting} color="secondary" innerRef={(ref) => { this.deleteCancel = ref; }} onClick={() => this.closeModal()}>Cancel</Button>
          </ModalFooter>
        </Modal>

        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>

                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G02135.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Volcano Location Information" aria-label="Volcano Location Information">Please cite the NCEI Volcano Location Database</a>
                    </p>
                  </span>
                </div>

                <CardTitle tag="h2">{`Volcano Locations - ${volcanoLocations.size} Results Found`}</CardTitle>
                <ResultGrid
                  data={volcanoLocations}
                  sort={sort}
                  columnChooser
                  visibleColumns={visibleColumns}
                  handleColumnsToggle={this.handleToggleColumns}
                  download
                  downloadPrefix="volcanoes"
                  downloadSearchParams={JSON.stringify(sp)}
                  edit={dataManager}
                  editing={editing}
                  handleEditToggle={this.handleEditToggle}
                  initialValues={initialValues}
                  handleSubmit={this.handleSubmit}
                  editConfirmationOpen={editConfirmationOpen}
                  hazardName="Volcano Locations"
                  saving={saving}
                  handleCancel={cancelEditConfirmation}
                  formData={formData}
                  initialFormData={initialFormData}
                  openEditConfirmation={openEditConfirmation}
                  formToJson={formToJson}
                  defaultColumns={defaultColumns}
                  defaultSort={defaultSort}
                  minColumns={minColumns}
                >
                  {dataManager && (
                    <Column alwaysVisible downloadable={false} id="del" cell={({ row }) => (<DeleteIcon handleClick={() => this.handleDeleteClick(row.get('id'))} />)} width={30}>
                      <DeleteIcon />
                    </Column>
                  )}
                  {dataManager && (
                    <Column alwaysVisible downloadable={false} id="edit" cell={({ row }) => renderEditLink(row.get('id'))} width={30}>
                      <EditIcon />
                    </Column>
                  )}
                  {dataManager && (
                  <Column id="id" width={50} sortable>NCEI ID</Column>
                  )}
                  {dataManager && (
                  <Column id="num" width={100} sortable helpModalId="volLocNum" cell={({ value, row }) => textCell(row, 'num', value, errors, editing)}>Previous Volcano Number</Column>
                  )}
                  <Column id="newNum" width={100} helpModalId="volLocNewNum" sortable cell={({ value, row }) => textCell(row, 'newNum', value, errors, editing)}>Volcano Number</Column>
                  <Column id="name" width={200} sortable helpModalId="volLocName" cell={({ value, row }) => textCell(row, 'name', value, errors, editing)}>Volcano Name</Column>
                  <Column id="country" width={150} sortable cell={({ value, row }) => textCell(row, 'country', value, errors, editing)}>Country</Column>
                  <Column id="region" width={50} sortable helpModalId="volLocRegions" cell={({ value, row }) => textCell(row, 'region', value, errors, editing)}>Region</Column>
                  <Column id="location" width={200} sortable helpModalId="volLocRegion" cell={({ value, row }) => textCell(row, 'location', value, errors, editing)}>Location</Column>
                  <Column id="latitude" width={100} sortable helpModalId="latitude" cell={({ value, row }) => latLonCell(row, 'latitude', value, errors, editing)}>Latitude</Column>
                  <Column id="longitude" width={100} sortable helpModalId="longitude" cell={({ value, row }) => latLonCell(row, 'longitude', value, errors, editing)}>Longitude</Column>
                  <Column id="elevation" width={80} sortable helpModalId="volLocElevation" cell={({ value, row }) => textCell(row, 'elevation', value, errors, editing)}>Elevation (m)</Column>
                  <Column id="morphology" width={150} sortable helpModalId="volLocType" cell={({ value, row }) => textCell(row, 'morphology', value, errors, editing)}>Type</Column>
                  <Column id="status" width={120} sortable helpModalId="volLocStatus" cell={({ value, row }) => textCell(row, 'status', value, errors, editing)}>Status</Column>
                  <Column id="timeErupt" width={80} sortable helpModalId="volLocTimeErupt" cell={({ value, row }) => textCell(row, 'timeErupt', value, errors, editing)}>Last Known Eruption</Column>
                </ResultGrid>

              </CardBody>
            </Card>
          </div>
        </div>

      </div>
    );
  }
}

VolcanoLocContainerUnwrapped.propTypes = {
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  volcanoLocations: ImmutablePropTypes.list.isRequired,
  getVolcanoLocations: PropTypes.func.isRequired,
  clearVolcanoLocations: PropTypes.func.isRequired,
  deleteVolcanoLocation: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  clearVolcanoLocationRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  getRegions: PropTypes.func.isRequired,
  clearVolcanoEventData: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  sort: ImmutablePropTypes.list.isRequired,

  saving: PropTypes.bool.isRequired,
  bulkEditVolcanoLocations: PropTypes.func.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  initialFormData: ImmutablePropTypes.map.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
  startEdit: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  initialValues: ImmutablePropTypes.map.isRequired,
  sortData: PropTypes.func.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['volcanoLocationSearchPage', 'fetched']),
    state.getIn(['volcanoLocationDataPage', 'fetchedRegions']),
  ].every(v => v),
  deleting: state.getIn(['volcanoLocationDataPage', 'deleting']),
  volcanoLocations: state.getIn(['volcanoLocationSearchPage', 'volcanoes']),
  searchRedirect: state.getIn(['volcanoLocationSearchPage', 'searchRedirect']),
  regions: state.getIn(['volcanoLocationDataPage', 'regions']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  sort: state.getIn(['volcanoLocationSearchPage', 'sort']),

  saving: state.getIn(['volcanoLocationDataPage', 'saving']),
  editConfirmationOpen: state.getIn(['volcanoLocationDataPage', 'editConfirmationOpen']),
  formData: state.getIn(['volcanoLocationDataPage', 'formData']),
  initialFormData: state.getIn(['volcanoLocationDataPage', 'initialFormData']),
  errors: state.getIn(['volcanoLocationDataPage', 'errors']),
  editing: state.getIn(['volcanoLocationDataPage', 'editing']),
  initialValues: state.getIn(['volcanoLocationDataPage', 'initialValues']),
  visibleColumns: state.getIn(['volcanoLocationDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoLocations: getVolcanoLocationsAc,
  clearVolcanoLocations: clearVolcanoLocationsAc,
  deleteVolcanoLocation: deleteVolcanoLocationAc,
  clearVolcanoLocationRedirect: clearVolcanoLocationRedirectAc,
  getRegions: getRegionsAc,
  clearVolcanoEventData: clearVolcanoEventDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
  bulkEditVolcanoLocations: bulkEditTsunamisAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  startEdit: startEditAc,
  cancelEdit: cancelEditAc,
}, dispatch);

export const VolcanoLocContainer = connect(mapStateToProps, mapDispatchToProps)(VolcanoLocContainerUnwrapped);
